module.exports = __webpack_public_path__ + "static/media/sagar-narrow.b6359a8e.png";